import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { saveAuthToken } from "../lib/authToken";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    if (!sessionId) {
      navigate("/register", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error("auth failed");
        // Phase VV.63 — persist session token for Capacitor cold-start
        // reliability.
        try {
          const j = await r.json();
          if (j && j.session_token) saveAuthToken(j.session_token);
        } catch (_) {
          /* body may be empty on some flows — ignore */
        }
        // Clean hash and go to feed
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/feed", { replace: true });
      } catch (e) {
        navigate("/register", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        background: "linear-gradient(180deg, #6cb8ff 0%, #b8dcff 100%)",
        fontFamily: "'Space Grotesk', sans-serif",
      }}
    >
      <p className="text-white/90 text-lg">Signing you in…</p>
    </div>
  );
}
